import { useEffect, useState } from "react";
import { Checkbox } from "../../../components/Checkbox";
import { Hairline } from "../../../components/Hairline";
import { Label } from "../../../components/Label";

export const BenefitEnvironmentOld = ({ benefit, brands, onChange }) => {
  const [brandsSelected, setBrands] = useState([]);

  useEffect(() => {
    onChange({ ...benefit, brands_valid: brandsSelected });
  }, [brandsSelected]);

  const addBrand = (brand) => {
    if (brandsSelected.includes(brand)) {
      setBrands(brandsSelected.filter((item) => item !== brand));
      return;
    }
    setBrands([...brandsSelected, brand]);
  };

  return (
    <>
      <Label
        text={"Onde o benefício poderá ser utilizado?"}
        className={"mb-20"}
      />
      {(brands || []).map((item) => {
        return (
          <Checkbox
            key={item.id}
            family="place"
            className="mb-10"
            value={item.id}
            checked={brandsSelected.includes(item.id)}
            onChange={() => addBrand(item.id)}
          >
            {item.name}{" "}
          </Checkbox>
        );
      })}
    </>
  );
};
